import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { postTransaction } from "../api";

export interface ErrorResponse {
  response?: {
    data?: {
      message?: string;
    };
  };
  message?: string;
}

export const useCreateTransaction = () => {
  const router = useNavigate();
  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: postTransaction,
    onSuccess() {
      queryClient.refetchQueries({ queryKey: ["TRANSACTION"] });
      router("/order-list");
      toast.success("Success Create Transaction");
    },
    onError: (error: ErrorResponse) => {
      const message =
        error?.response?.data?.message || "Failed to create transaction";
      toast.error(message);
    },
  });

  return { transaction: mutate, isPending };
};
